<template>
  <div style="overflow: auto">
    <v-col cols="12">
      <table class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th>STT</th>
            <th>Image</th>
            <th>Product Title</th>
            <th>Created Date</th>
            <th>Due Date</th>
            <th>Total Sales</th>
            <th>Profitable</th>
          </tr>
        </thead>
        <tbody style="text-align: left">
          <tr v-for="(value, text, index) in listData" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <img :src="value.product_thumbnail" style="width: 100px" />
            </td>
            <td>
              <div>{{ text }}</div>
              <div>{{ value.product_title }}</div>
            </td>
            <td>{{ value.product_created_date }}</td>
            <td>{{ value.product_due_date }}</td>
            <td>{{ value.total_sales }}</td>
            <td>
              <template v-if="value.is_profitable">Yes</template>
              <template v-else>No</template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr></tr>
        </tfoot>
      </table>
    </v-col>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
//import moment from 'moment-timezone'
//import axios from "axios"

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "KPIIdea",
  props: {
    userId: String,
    listData: Object,
  },
  data: () => ({
    menu2: false,
    report_month: new Date().toISOString().substr(0, 7),
  }),
  methods: {},
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>